@if(view === 'header') {
  <div class="modal-header row draggable-drag-ico">
    <div class="col col-auto">
      <img [src]="config.data?.icon" [alt]="(config.data?.name || 'App') + ' icon'" title="{{config.data?.name || 'App'}}" class="logo ms-1" width="32" height="32" loading="lazy" />
    </div>
    <div class="col text-center">
      <div class="row">
        <div class="col col-auto text-white">
          <h5 class="modal-title text-white ms-2">
            {{config.data?.name}}
          </h5>
        </div>
        <div class="col text-center">
          <button mdbRipple type="button" [disabled]="currentRunningApp.config?.data?.isMaximized" class="btn-floating text-white btn btn-sm btn-warning me-1" aria-label="Close"
                  (click)="minimizeModal()">
            <i class="fas fa-window-minimize fa-lg"></i>
          </button>
          @if(currentRunningApp.config?.data?.isMaximized) {
            <button mdbRipple t ype="button" class="btn-floating text-white btn bnt-primary btn-sm btn-success me-1" aria-label="Close" (click)="restoreModal()">
              <i class="fa fa-window-restore fa-lg"></i>
            </button>
          }
          @if(!currentRunningApp.config?.data?.isMaximized) {
            <button mdbRipple type="button" [disabled]="currentRunningApp.config?.data?.isMaximized || config.data?.externalUrl" class="btn-floating text-white btn btn-sm btn-success me-1"
                    aria-label="Close" (click)="maximizeModal()">
              <i class="fas fa-window-maximize fa-lg"></i>
            </button>
          }
          <button mdbRipple type="button" class="btn-floating text-white btn btn-sm btn-danger" aria-label="Close" (click)="closeModal()">
            <i class="fas fa-window-close fa-lg"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col col-auto text-end">
      <ng-template #squareTemplate let-squares="squares" let-homeView="homeView">
        @for(square of squares; track square.id; let i = $index) {
          @if(homeView !== square.ref) {
          <div class="square mdb-ripple cursor-pointer" (click)="moveModalToSquare(square, popover)">
            <div class="square-text fw-3 fw-bold">
              {{square.name}}
            </div>
            <img [src]="square.url" [alt]="square.name + ' desktop thumbnail'" title="{{square.name || 'Desktop'}}" width="100" height="100" class="rounded-3 user-avatar desktop-image" loading="lazy" />
          </div>
          }
        }
      </ng-template>

      <button mdbRipple type="button" trigger="click" placement="bottom" [disabled]="true" #popover="mdbPopover"
              [mdbPopoverData]="{squares: popupData()?.app?.squares, homeView: homeView}" [mdbPopover]="squareTemplate"
              mdbPopoverTitle="Move to Desktop" mdbPopoverTrigger="click"
              class="btn-floating text-white btn bnt-primary btn-sm btn-info" aria-label="Close">
        <i class="fas fa-arrows-alt fa-lg"></i>
      </button>
    </div>
  </div>
}

@if(view === 'body') {
  <div class="modal-body p-0">
    @if(!config.data?.externalUrl) {
        @if(config.data?.useProxy) {
          <!-- Display proxied content -->
          <div class="p-4 overflow-auto" [id]="'app-' + config.data?._id">
            @if(isLoading) {
              <div class="text-center p-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-3">Loading content...</p>
              </div>
            }
            @if(proxyError) {
              <div class="alert alert-danger m-3" role="alert">
                <h5 class="alert-heading">Error Loading Content</h5>
                <p>{{ proxyError }}</p>
                <button class="btn btn-sm btn-primary" (click)="reloadProxiedContent()">
                  <i class="fas fa-sync-alt"></i> Retry
                </button>
              </div>
            }
            @if(proxiedContent && !isLoading) {
              <div class="proxied-content">
                <pre>{{ proxiedContent | json }}</pre>
              </div>
            }
        </div>
      } @else {
        <iframe title="App Content" [id]="'app-' + config.data?._id" [src]="config.data?.url | safe:'resourceUrl'" class="iframe-content"></iframe>
      }
    } @else {
    <div class="dataFlow" [id]="'app-' +  config.data?._id">
      @switch (config.data?.name?.toLowerCase()) {
        @case ('about') {
          <app-about></app-about>
        }
        @case ('chat') {
          <app-chat></app-chat>
        }
        @case ('app management') {
          <app-manager [desktopView]="config.data?.homeView"></app-manager>
        }
        @case ('settings') {
          <app-settings></app-settings>
        }
        @case ('calendar') {
          <app-calendar></app-calendar>
        }
        @case ('file manager') {
          <app-file-manager></app-file-manager>
        }
        @case ('calculator') {
          <app-calculator></app-calculator>
        }
        @case ('ews') {
          <app-ews></app-ews>
        }
        @default {
          <p>COMING SOON...</p>
        }
      }
    </div>
    }
  </div>
}
